import type React from 'react';
import { useMeetingSwitchRequest } from '../../hooks/useMeetingSwitchRequest';
import { MeetingSwitchDialog } from './MeetingSwitchDialog';

/**
 * Mounts the meeting-switch prompt for the whole popup.
 *
 * Sits at the provider level rather than inside the meeting route so it renders
 * above the Jitsi iframe and survives route changes within the window. Renders
 * nothing unless the opener asks — which only happens in a meeting popup.
 */
const MeetingSwitchPrompt: React.FC = () => {
  const { request, accept, decline } = useMeetingSwitchRequest();

  if (!request) {
    return null;
  }

  return (
    <MeetingSwitchDialog meetingId={request.meetingId} onConfirm={accept} onCancel={decline} />
  );
};

export { MeetingSwitchPrompt };
